module.exports = __webpack_public_path__ + "static/img/home-new3.c4ece02b.jpeg";